import moment from "moment";
import React, { useMemo, useState } from "react";
import { PiEye, PiEyeSlash, PiMapPinLineFill } from "react-icons/pi";
import { useHistory } from "react-router-dom";
import ModalAlt from "../../../components/modal/ModalAlt";
import { ROLE } from "../../../constants/common";
import { PROPOSAL } from "../../../constants/routes";
import { useContextState } from "../../../context/ContextProvider";
import { checkIsAllowed } from "../../../helpers/helpers";
import { residential } from "../../../resources/js/icons";
import P from "../../../shared/typography/P";
import ReAssignForm from "../../property/ReAssignForm";

const VisitsCard = ({
    visit,
    setOpenNotification = () => {},
    getSurveyVisitList,
    filterOptions,
    visitPage,
    showNumber,
    setShowNumber,
}) => {
    const history = useHistory();
    const [isOpen, setIsOpen] = useState(false);
    const { state } = useContextState();
    const handleClose = () => {
        getSurveyVisitList(
            filterOptions.duration,
            filterOptions.assignee,
            visitPage?.selected
        );
        setIsOpen((prev) => !prev);
    };

    const formattedDate = useMemo(
        () => moment(visit?.surveyDate * 1000).format("DD/MM/yyyy"),
        [visit?.surveyDate]
    );

    const formattedTime = useMemo(
        () => moment(visit?.surveyDate * 1000).format("hh:mm A"),
        [visit?.surveyDate]
    );
    return (
        <>
            <div className="mb-2">
                <div className="flex justify-between items-center gap-1">
                    <div className="flex items-center gap-1  max-w-[50%]">
                        <img
                            src={residential}
                            alt="dashboard"
                            className="h-2"
                            loading="lazy"
                        />
                        <P
                            role="button"
                            onClick={() => {
                                setOpenNotification(false);
                                history.push(`${PROPOSAL}/${visit?.plantId}`);
                            }}
                            className="font-vietnam text-xs font-medium text-blue hover:underline hover:cursor-pointer line-clamp-1"
                        >
                            {visit?.plantName}
                        </P>
                    </div>

                    <div className="flex items-center gap-1 max-w-[50%]">
                        <P className="font-vietnam text-xs text-secondary">
                            {formattedDate}
                        </P>
                        <div className="w-0.5 h-0.5 bg-secondary rounded-full"></div>
                        <P className="font-vietnam text-xs text-secondary">
                            {formattedTime}
                        </P>
                    </div>
                </div>
                <div className="flex items-center justify-between gap-1 my-1 ">
                    <P className="text-xs text-primary  font-vietnam max-w-[50%] ">
                        {visit?.contactPersonName}
                    </P>

                    <div className="flex justify-end items-center gap-0.5 max-w-[50%] ">
                        <P className="text-xs text-primary  font-vietnam">
                            {showNumber === visit?.surveyId
                                ? visit?.contactPersonPhone
                                : visit?.contactPersonPhone.slice(0, 7) +
                                  "XXXXX"}
                        </P>
                        {showNumber !== visit?.surveyId ? (
                            <PiEye
                                role="button"
                                onClick={() => setShowNumber(visit?.surveyId)}
                                className="text-base hover:cursor-pointer"
                            />
                        ) : (
                            <PiEyeSlash
                                role="button"
                                onClick={() => setShowNumber(null)}
                                className="text-base hover:cursor-pointer"
                            />
                        )}
                    </div>
                </div>

                <div className="flex items-center justify-between gap-1 my-1">
                    <P className="text-xs text-secondary font-vietnam max-w-[50%] line-clamp-1">
                        {visit?.assigneeName}
                    </P>

                    <div className="flex items-center justify-end max-w-[50%] gap-0.5">
                        <P className="text-xs text-secondary font-vietnam truncate whitespace-nowrap overflow-hidden text-ellipsis">
                            {visit?.address}
                        </P>
                        <PiMapPinLineFill className="text-base shrink-0" />
                    </div>
                </div>
                <div className="flex justify-between">
                    {checkIsAllowed(state?.user?.roles, [ROLE.SUPER_ADMIN]) && (
                        <button
                            onClick={() => {
                                setOpenNotification((prev) => !prev);
                                if (document.body.clientWidth < 1024) {
                                    history.push(
                                        `/admin/dashboard/generate/${visit.plantId}?current=1`
                                    );
                                } else {
                                    setIsOpen((prev) => !prev);
                                }
                            }}
                            className="text-sm lg:text-base  text-blue font-vietnam underline font-light"
                        >
                            Reassign
                        </button>
                    )}
                    <a
                        href={`https://www.google.com/maps/dir/?api=1&destination=${visit?.lat},${visit?.lon}`}
                        target="_blank"
                        onClick={() => {
                            setOpenNotification((prev) => !prev);
                        }}
                        className="text-sm lg:text-base text-blue font-vietnam underline font-light"
                        rel="noopener noreferrer"
                    >
                        Direction
                    </a>
                </div>
            </div>
            <div className="hidden lg:block">
                <ModalAlt
                    isOpen={isOpen}
                    contentClass={"bg-white"}
                    onClose={() => {
                        setIsOpen((prev) => !prev);
                    }}
                    innerTimes={false}
                    topPadding={"20px"}
                >
                    <div className="bg-white rounded-2">
                        <div className="bg-gray-100 p-1 rounded-lg mb-1 w-full text-center">
                            <P>Reassign</P>
                        </div>
                        <ReAssignForm
                            surveyD={visit?.surveyDate}
                            details={visit}
                            plantId={visit?.plantId}
                            setIsOpen={handleClose}
                        />
                    </div>
                </ModalAlt>
            </div>
        </>
    );
};

export default React.memo(VisitsCard);
